__turbopack_context__.v({
  "title": "SectionTitle-module-scss-module__nlwNga__title",
});
